import { CoreIcon } from '../core-icon';
import sendSVG from '../../assets/icons/send.svg';
import type { IconProps } from '../core-icon';

export const SendIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={sendSVG} {...props} />;
};
